import React, { useEffect, useLayoutEffect } from 'react'
import Home from '../Sections/Home'
import Service from '../Sections/Service'
import Values from '../Sections/Values'
import Repair from '../Sections/Repair'
import "../Styles/Landing.css"
import Products from '../Sections/Products'
import Color from '../Components/Colors/Color'
import Carousel from '../Sections/Carousel'
import Testimonials from '../Sections/Testimonials'
import Contact from '../Sections/Contact'
import { useStateContext } from '../Contexts/productsCardContext'
import { useNavbarStateContext } from '../Contexts/NavbarContect'


const Landing = () => {
  const {setPage} = useStateContext();
  const {drawerOpen, setDrawerOpen} = useNavbarStateContext();

  useEffect(() => {
    setPage('landing')
    
    window.scrollTo(0,0);
  }, [])

  return (
    <div className='landing-page-container' style={{backgroundColor: Color.primaryBackground}}>
        <Home />
        <Service />
        <Values />
        <Repair />
        <Products />
        <Carousel />
        {/* <Testimonials /> */}
        <Contact />
    </div>
  )
}

export default Landing